import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/feature/SectionHeading';
import { articles } from '@/mocks/articles';

export default function LatestDig() {
  const latest = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 4);
  const ranking = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 5);
  const tagCloud = Array.from(new Set(articles.flatMap((a) => a.tags))).slice(0, 12);

  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="Latest"
            title="最新起底"
            desc="按发布时间排列的深度拆解，平均每篇核查超过 72 小时。"
          />
          <Link
            to="/topics"
            className="inline-flex w-fit items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-600"
          >
            进入专题分类
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,2.2fr)_minmax(0,1fr)]">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            {latest.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>

          <aside className="space-y-8">
            <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-6">
              <h3 className="font-heading flex items-center gap-2 text-base font-bold text-foreground-950">
                <i className="ri-fire-line text-primary-500" />
                深扒热榜
              </h3>
              <div className="mt-4">
                {ranking.map((article) => (
                  <ArticleCard key={article.id} article={article} variant="compact" />
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-6">
              <h3 className="font-heading text-base font-bold text-foreground-950">标签索引</h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {tagCloud.map((tag) => (
                  <Link
                    key={tag}
                    to={`/topics?q=${encodeURIComponent(tag)}`}
                    className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 transition-colors hover:bg-secondary-200"
                  >
                    {tag}
                  </Link>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}